<template>
    <div class="c-date-navigation">
        <GotoMonth :selected-month="initialMonth"/>
        <button v-if="previousButton" @click="previous" :disabled="buttonDisabledState.previous">Previous month</button>
        <button v-if="nextButton" @click="next" :disabled="buttonDisabledState.next">Next month</button>
    </div>
</template>

<script>
    import moment from 'moment'
    import {EventBus} from "../event-bus"
    import GotoMonth from "./GotoMonth"

    export default {
        name: "DateNavigation",
        props: {
            firstInstance: {
                type: String,
                default: "",
            },
            lastInstance: {
                type: String,
                default: "",
            },
            nextButton: {
                type: Boolean,
                default: true,
            },
            previousButton: {
                type: Boolean,
                default: true,
            },
            goToMonthList: {
                type: Boolean,
                default: true,
            }
        },
        components: {
            GotoMonth,
        },
        data() {
            return {
                initialMonth: this.setInitialMonth(),
                lastMonth: this.setLastMonth(),
                currentSelectedMonth: this.setInitialMonth(),
                buttonDisabledState : {
                    next: false,
                    previous: true,
                }
            }
        },
        mounted() {
            EventBus.$on('updateMonth', this.updateButtonDisabledState)
        },
        methods: {
            setInitialMonth() {
                return this.firstInstance ? moment(this.firstInstance).format('MMMM YYYY') : moment().format('MMMM YYYY')
            },
            setLastMonth() {
                return this.lastInstance ? moment(this.lastInstance).format('YYYY-MM') : moment().add(2, 'years').format('YYYY-MM')
            },
            next() {
                EventBus.$emit('next')
            },
            previous() {
                EventBus.$emit('previous')
            },
            updateButtonDisabledState(month, button) {
                if ((button === 'next' || button === 'gotoMonth') && month === this.lastMonth) {
                    this.buttonDisabledState.next = true
                    this.buttonDisabledState.previous = false
                } else if ((button === 'previous' || button === 'gotoMonth') && month === this.initialMonth) {
                    this.buttonDisabledState.next = false
                    this.buttonDisabledState.previous = true
                } else {
                    this.buttonDisabledState.next = false
                    this.buttonDisabledState.previous = false
                }
            }
        }
    }
</script>